export const NEW = 'New'
export const DRAFT = 'Draft'
export const OPEN = 'Open'
export const SUSPENDED = 'Suspended'
export const CANCELED = 'Canceled'